import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode, normalizeClass, createElementBlock, Fragment, renderList, toDisplayString } from "vue";
import { useDatePickerContext, DatePickerView, DatePickerTableCell, DatePickerTableCellTrigger } from "@ark-ui/vue/date-picker";
import { formatWeekDayLabel } from "../formatWeekDayLabel.js";
import Header from "./Header.vue.js";
const _hoisted_1 = { class: "elfie-range__table-cell" };
const _hoisted_2 = { class: "elfie-range__day-cell" };
const _hoisted_3 = { class: "elfie-range__day-cell-inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DayViewRange",
  setup(__props) {
    const datePicker = useDatePickerContext();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DatePickerView), { view: "day" }, {
        default: withCtx(() => [
          createVNode(Header),
          createElementVNode("table", {
            class: normalizeClass(["elfie-range__table", { "is-range-complete": unref(datePicker).value.length === 2 }])
          }, [
            createElementVNode("thead", null, [
              createElementVNode("tr", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).weekDays, (weekDay, id) => {
                  return openBlock(), createElementBlock("th", {
                    key: id,
                    class: "elfie-range__table-header-cell"
                  }, toDisplayString(unref(formatWeekDayLabel)(weekDay)), 1);
                }), 128))
              ])
            ]),
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).weeks, (week, weekId) => {
                return openBlock(), createElementBlock("tr", { key: weekId }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(week, (day, dayId) => {
                    return openBlock(), createBlock(unref(DatePickerTableCell), {
                      key: dayId,
                      value: day,
                      "as-child": ""
                    }, {
                      default: withCtx(() => [
                        createElementVNode("td", _hoisted_1, [
                          createVNode(unref(DatePickerTableCellTrigger), { "as-child": "" }, {
                            default: withCtx(() => [
                              createElementVNode("button", _hoisted_2, [
                                createElementVNode("span", _hoisted_3, toDisplayString(day.day), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))
                ]);
              }), 128))
            ])
          ], 2)
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DayViewRange.vue2.js.map
